import { Box, Button, Paper } from "@mui/material";
import { AbstractTypedDataForm } from "../../components/data/DataForm";
import DatePicker from "../../components/form/DatePicker";
import { FormTextInput, TextInput } from "../../components/form/TextInput";
import { Meter } from "../../models/Types";
import { isMobile } from "../../utils";
import HouseCombo from "../houses/HouseCombo";
import { meterTariffStore } from "../measure/MeterTariffCombo";
import TariffCombo from "../project/tariff/TariffCombo";

export function meterParse(d?: any) {
    const dto = (d || {}) as Meter;
    d?.CheckDate && (dto.CheckDate = new Date(d.CheckDate));
    d?.NextCheck && (dto.NextCheck = new Date(d.NextCheck));
    return dto;
}

export class MeterForm extends AbstractTypedDataForm<Meter> {
    protected getTypeId(): string {
        return 'Meter';
    }
    protected getTypeName(): React.ReactNode {
        return 'Счетчик';
    }

    buildButtons() {
        return [];
    }

    protected createEntity() {
        return meterParse();
    }

    onSave() {
        meterTariffStore.clear();
        return super.onSave();
    }

    onAfterDelete() {
        meterTariffStore.clear();
        return super.onSave();
    }

    protected buildItems(entity?: Meter | undefined): React.ReactNode {
        const disabled = this.isReadOnly();

        return <>
            <Paper sx={isMobile() ? { flex: 1 } : { minWidth: 500 }}>
                <FormTextInput required={true} label="Номер" name="Number" form={this} entity={entity} />
                <FormTextInput label="Наименование" name="Name" form={this} entity={entity} />
                <TextInput
                    required={true}
                    value={entity?.HouseId}
                    label="Домвладение"
                    name="HouseId"
                    onChange={this.onChange}
                    validator={v => v ? undefined : 'Необходимо выбрать домвладение'}
                    refValidator={val => this.addValidator('HouseId', 'HouseId', v => val(v))}
                    component={(onChange, error) => <HouseCombo
                        name="HouseId"
                        error={!!error}
                        value={entity?.HouseId}
                        disabled={disabled}
                        onChange={onChange} />} />

                <DatePicker label="Дата поверки" value={entity?.CheckDate} onChange={v => entity!.CheckDate = v?.toDate() || new Date()} disabled={disabled} />
                <DatePicker label="Следующая поверка" value={entity?.NextCheck} onChange={v => entity!.NextCheck = v?.toDate() || new Date()} disabled={disabled} />

                <TextInput
                    required={true}
                    value={entity?.Tariffs}
                    label="Тариф(ы)"
                    name="Tariffs"
                    onChange={this.onChange}
                    validator={v => (v as number[])?.length ? undefined : 'Необходимо выбрать тариф(ы)'}
                    refValidator={val => this.addValidator('Tariffs', 'Tariffs', v => val(v))}
                    component={(onChange, error) => <TariffCombo
                        name="Tariffs"
                        multiple={true}
                        error={!!error}
                        value={entity?.Tariffs}
                        disabled={disabled}
                        onChange={onChange} />} />

                {disabled ? null : <Box sx={{ display: 'flex' }}>
                    <div style={{ flex: 1 }} />
                    {<Button variant="contained" type="submit">Сохранить</Button>}
                </Box>}
            </Paper>
        </>;
    }
}